import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, FormHelperText, FormLabel, ToggleButton, ToggleButtonGroup } from '@mui/material';
import HookFormUtils from '../../common/components/hook-form/HookFormUtils';
import { CLINIC_TIME_FORMAT_OPTIONS } from '../../common/services/ClinicTimeFormatUtils';

export default function ClinicTimeFormatToggleField({
  control,
  errors,
  schema = 'time_format',
  prefix = null,
  label = 'Select Time Format',
}) {
  const error = HookFormUtils.getFieldError(errors, schema, prefix);
  const fieldName = HookFormUtils.getSchemaName(schema, prefix);

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth error={!!error}>
          <FormLabel sx={{ mb: 1, color: 'text.primary', fontWeight: 500 }}>{label}</FormLabel>
          <ToggleButtonGroup
            value={value || null}
            exclusive
            fullWidth
            onChange={(_event, newValue) => {
              if (newValue !== null) {
                onChange(newValue);
              }
            }}
            sx={{
              '& .MuiToggleButton-root': {
                textTransform: 'none',
                borderColor: 'rgba(0, 0, 0, 0.23)',
                py: 1.2,
                fontSize: '0.9rem',
                color: 'text.primary',
                '&.Mui-selected': {
                  backgroundColor: '#1f2a44',
                  color: '#fff',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: '#1f2a44',
                },
              },
            }}
          >
            {CLINIC_TIME_FORMAT_OPTIONS.map(option => (
              <ToggleButton key={option.value} value={option.value}>
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
}
